"use strict";

import React, { Component } from "react";
import PropTypes, {element} from "prop-types";

import 'flot/dist/es5/jquery.flot';
import 'flot/source/jquery.flot.time';
import 'flot/source/jquery.flot.categories';
import 'flot/source/jquery.flot.logaxis';

class VideoEnrichmentAvgMinMaxChart extends Component {
    static propTypes = {
        eventChartId: PropTypes.string,
        options: PropTypes.object,
        colorAvg: PropTypes.string,
        colorMin: PropTypes.string,
        colorMax: PropTypes.string,
        data: PropTypes.array,
    };

    static defaultProps = {
        colorAvg: '#00a7d0',
        colorMin: '#008d4c',
        colorMax: '#d33724',
        data: [],
    };

    constructor(props) {
        super(props);

        let defaultOptions = {
            grid: {
                borderWidth: { top: 0, right: 0, bottom: 1, left: 0 },
                markings: {xaxis: [], yaxes: []} ,
            },
            xaxis: {
                mode: "time",
                timezone: "browser",
                timeBase: "milliseconds",
            },
            series: {
                stack: false,
                color: props.color,
                bars: {
                    show: false,
                },
                lines: {
                    show: true,
                    fill: true,
                    fillColor: { colors: [ { opacity: 0.6 }, { opacity: 1 } ] },
                },
            },
        };

        this.state = {
            options: props.options || defaultOptions,
        };
    }

    componentDidMount() {
        this.initFlotChart();
    }

    componentDidUpdate(prevProps, prevState) {
        this.initFlotChart();
    }

    initFlotChart() {
        const { eventChartId, data, colorAvg, colorMin, colorMax } = this.props;
        const { options } = this.state;

        const dataAvg = {
            label: "Avg.",
            data: data.map(el => [el[0], el[1]]),
            color: colorAvg,
            fill: true,
            fillColor: { colors: [ { opacity: 0.6 }, { opacity: 1 } ] },
        };
        const dataMin = {
            label: "Min.",
            data: data.map(el => [el[0], el[2]]),
            color: colorMin,
            fill: true,
            fillColor: { colors: [ { opacity: 0.6 }, { opacity: 1 } ] },
        };
        const dataMax = {
            label: "Max.",
            data: data.map(el => [el[0], el[3]]),
            color: colorMax,
            fill: true,
            fillColor: { colors: [ { opacity: 0.6 }, { opacity: 1 } ] },
        };

        $.plot($('#' + eventChartId), (data && [dataMax, dataAvg, dataMin]) || [[]], options);
    }

    render() {
        const { eventChartId, data } = this.props;

        return (
            <div>
                <div id={eventChartId} ref='eventchart' style={{height:"200px", display: data && (data.length > 0) ? "block" : "none"}} />
                <div style={{height:"200px", display: data && (data.length > 0) ? "none" : "block"}}>
                    <h2>Loading...</h2>
                </div>
            </div>
        )
    }
}

export default VideoEnrichmentAvgMinMaxChart;
